import firebase from "firebase/app";
import "firebase/auth";
import authConfig from "../auth_config.json";

const firebaseConfig = authConfig.firebaseConfig;

firebase.initializeApp(firebaseConfig);
export const auth = firebase.auth();
